var TrainCards;
(function (TrainCards) {
    const $trainCards = document.querySelectorAll('.train-card');
    if ($trainCards.length) {
        $trainCards.forEach((trainCard) => {
            if (!trainCard.getAttribute('data-lazy') && !trainCard.classList.contains('deal-category'))
                initTrainCard(trainCard);
        });
        function initTrainCard($trainCard) {
            const decodeSizesDesk = {
                normal: 32,
                small: 16,
                xsmall: 8,
                none: 0,
            };
            const decodeSizesMobile = {
                normal: 16,
                small: 16,
                xsmall: 8,
                none: 0,
            };
            const attrClusterSize = $trainCard.getAttribute('data-cluster-size')
                ? parseInt($trainCard.getAttribute('data-cluster-size'))
                : 1;
            const attrClusterSizeMobile = $trainCard.getAttribute('data-cluster-size-mobile')
                ? parseInt($trainCard.getAttribute('data-cluster-size-mobile'))
                : 1;
            const attrClusterOffset = $trainCard.getAttribute('data-cluster-offset')
                ? parseInt($trainCard.getAttribute('data-cluster-offset'))
                : 0;
            const marginSize = $trainCard.getAttribute('data-margin-size') || 'normal';
            const attrNoCarousel = $trainCard.hasAttribute('data-no-carousel') &&
                ($trainCard.getAttribute('data-no-carousel') || 'all');
            const trainCardOffestBox = $trainCard.querySelector('.train-card-offset-box');
            const slideContainer = $trainCard.querySelector('.slide-container');
            let trainCardSlidesOriginal = $trainCard.querySelectorAll('.slide');
            let trainCardSlidesOffest = attrClusterOffset
                ? [].slice.call(trainCardSlidesOriginal, 0, attrClusterOffset)
                : [];
            let trainCardSlides = [].slice.call(trainCardSlidesOriginal, 0);
            let currentIndex = 0;
            const leftControlArrow = $trainCard.querySelector('.control-arrow-left');
            const rightControlArrow = $trainCard.querySelector('.control-arrow-right');
            let isMobile;
            let noCarousel;
            let slideMargin;
            let slideClusterWidth;
            let clusterSize;
            let slideWidth;
            const getSlideSizes = () => {
                var _a;
                isMobile = window.innerWidth < 992; 
                noCarousel = isMobile
                    ? attrNoCarousel === 'all' || attrNoCarousel === 'mobile'
                    : attrNoCarousel === 'all' || attrNoCarousel === 'desktop';
                slideMargin = isMobile
                    ? decodeSizesMobile[marginSize]
                    : decodeSizesDesk[marginSize];
                slideClusterWidth =
                    ((_a = $trainCard.querySelector('.train-card-box')) === null || _a === void 0 ? void 0 : _a.clientWidth) ||
                        0;
                clusterSize = isMobile
                    ? attrClusterSizeMobile
                    : attrClusterSize;
                slideWidth =
                    slideClusterWidth / clusterSize -
                        (slideMargin * (clusterSize - 1)) / clusterSize; 
                if (isMobile && !noCarousel) {
                    slideWidth = slideWidth - slideMargin * (2 / clusterSize);
                }
                if (attrClusterOffset) {
                    if (isMobile) {
                        for (let i = 0; i < trainCardSlidesOffest.length; i++) {
                            trainCardSlides = [].slice.call(trainCardSlidesOriginal, attrClusterOffset);
                            const slide = trainCardSlidesOffest[i];
                            trainCardOffestBox.appendChild(slide);
                        }
                    }
                    else {
                        trainCardSlides = [].slice.call(trainCardSlidesOriginal, 0);
                        trainCardOffestBox.innerHTML = '';
                        slideContainer.innerHTML = '';
                        for (let i = 0; i < trainCardSlides.length; i++) {
                            const slide = trainCardSlides[i];
                            slideContainer.appendChild(slide);
                        }
                    }
                }
            };
            const setSlide = (newIndex) => {
                currentIndex = newIndex;
                setControls();
                let slideOffset = isMobile
                    ? (slideWidth + slideMargin) * clusterSize
                    : slideClusterWidth + slideMargin;
                $trainCard.getElementsByClassName('slide-container')[0].style.transform =
                    'translateX(calc(-' +
                        slideOffset +
                        'px * ' +
                        newIndex +
                        '))'; 
                for (let index = 0; index < trainCardSlides.length; index++) {
                    let classes = trainCardSlides[index].classList;
                    if (noCarousel) {
                        classes.remove('inactive');
                    }
                    else if (currentIndex === Math.floor(index / clusterSize)) {
                        classes.remove('inactive');
                    }
                    else {
                        classes.add('inactive');
                    }
                }
            };
            const prevSlide = () => {
                if (currentIndex > 0) {
                    setSlide((Math.ceil(trainCardSlides.length / clusterSize) +
                        currentIndex -
                        1) %
                        Math.ceil(trainCardSlides.length / clusterSize));
                }
            };
            const nextSlide = () => {
                if (currentIndex <
                    Math.ceil(trainCardSlides.length / clusterSize) - 1) {
                    setSlide((Math.ceil(trainCardSlides.length / clusterSize) +
                        currentIndex +
                        1) %
                        Math.ceil(trainCardSlides.length / clusterSize));
                }
            };
            const setSlideSize = () => {
                for (let index = 0; index < trainCardSlides.length; index++) {
                    let currSlide = trainCardSlides[index];
                    currSlide.style.width = slideWidth + 'px';
                    if (!noCarousel || (index + 1) % clusterSize !== 0) {
                        currSlide.style.marginRight = slideMargin + 'px';
                    }
                    else {
                        currSlide.style.marginRight = '0';
                    }
                    if (noCarousel) {
                        currSlide.style.marginBottom = slideMargin + 'px';
                    }
                    if (currSlide.classList.contains('border') &&
                        (index + 1) % clusterSize == 0) {
                        currSlide.style.borderRight = 'none';
                    }
                }
                if (isMobile && attrClusterOffset) {
                    for (let index = 0; index < trainCardSlidesOffest.length; index++) {
                        let currSlide = trainCardSlidesOffest[index];
                        currSlide.style.width = '100%';
                        currSlide.style.marginRight = '0';
                    }
                }
            };
            const adjustSlideHeight = () => {
                const slides = document.querySelectorAll('.slide.card-images');
                if (slides.length === 0) {
                    console.warn('No slides found to adjust.');
                    return;
                }
                slides.forEach(slide => {
                    const slideElement = slide;
                    const imgElement = slideElement.querySelector('img');
                    if (imgElement && imgElement.classList.contains('lozad')) {
                        const heightAttr = imgElement.getAttribute('height');
                        if (heightAttr) {
                            slideElement.style.height = `${parseInt(heightAttr, 10)}px`;
                        }
                    }
                });
            };
            const setControls = () => {
                if (leftControlArrow && rightControlArrow) {
                    if (Math.ceil(trainCardSlides.length / clusterSize) > 1) {
                        if (currentIndex > 0) {
                            leftControlArrow.classList.add('visible');
                        }
                        else {
                            leftControlArrow.classList.remove('visible');
                        }
                        if (currentIndex <
                            Math.ceil(trainCardSlides.length / clusterSize) - 1) {
                            rightControlArrow.classList.add('visible');
                        }
                        else {
                            rightControlArrow.classList.remove('visible');
                        }
                    }
                    else {
                        leftControlArrow.classList.remove('visible');
                        rightControlArrow.classList.remove('visible');
                    }
                }
            };
            const hammer = new Hammer($trainCard);
            getSlideSizes();
            setSlideSize();
            setSlide(currentIndex);
            if (noCarousel) {
                hammer.off('swipeleft');
                hammer.off('swiperight');
            }
            else {
                hammer.on('swipeleft', () => {
                    nextSlide();
                });
                hammer.on('swiperight', () => {
                    prevSlide();
                });
            }
            if (leftControlArrow) {
                leftControlArrow.setAttribute('aria-label', 'Slide1');
                leftControlArrow.addEventListener('click', () => {
                    prevSlide();
                });
            }
            if (rightControlArrow) {
                rightControlArrow.setAttribute('aria-label', 'Slide2');
                rightControlArrow.addEventListener('click', () => {
                    nextSlide();
                });
            }
            window.addEventListener('resize', () => {
                getSlideSizes();
                setSlideSize();
                setSlide(currentIndex);
                if (noCarousel) {
                    hammer.off('swipeleft');
                    hammer.off('swiperight');
                }
                else {
                    hammer.on('swipeleft', () => {
                        nextSlide();
                    });
                    hammer.on('swiperight', () => {
                        prevSlide();
                    });
                }
                adjustSlideHeight();
            });
            adjustSlideHeight();
        }
        document.addEventListener('init-train-card', data => {
            const $card = data.target.querySelector(".train-card");
            initTrainCard($card);
        });
    }
})(TrainCards || (TrainCards = {}));
